var $07b770f6f5be779a$exports = {};
$07b770f6f5be779a$exports = {
    "endTime": `Terminar tempo`,
    "startTime": `Iniciar tempo`,
    "time": `Tempo`
};


export {$07b770f6f5be779a$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
